import { useCallback, useEffect } from "react";

export const useOutsideClickHandler = (
  callback: (event: MouseEvent) => void,
  refs: React.RefObject<HTMLElement>[],
) => {
  const checkIfClickedOutside = useCallback(
    (e: MouseEvent) => {
      const clickedInside = refs.some(
        (ref) => ref.current && ref.current.contains(e.target as Node),
      );

      if (!clickedInside) {
        callback(e);
      }
    },
    [callback, refs],
  );

  useEffect(() => {
    document.addEventListener("mousedown", checkIfClickedOutside);
    return () => {
      document.removeEventListener("mousedown", checkIfClickedOutside);
    };
  }, [checkIfClickedOutside]);
};
